module.exports = "<div class=\"pamplemousse\">\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n    <div class=\"pamplemousse__pip\"><i></i></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/ui/loading.html
// module id = 257
// module chunks = 0 15